import Header from '@/domains/NewHome/components/HeroSection/Header';
import {
  Announcements,
  GetInTouch,
  Hero,
  OneVillageMediaKit,
  OurAwards,
  PressHighlights,
} from '@/domains/press-center';

import { PageLayout } from '../widgets';

const PressCenterPage = (): JSX.Element => (
  <PageLayout header={<Header darkLogo />} showMobTabBar={false}>
    <Hero />
    <Announcements />
    <PressHighlights />
    <GetInTouch />
    <OurAwards />
    <OneVillageMediaKit />
  </PageLayout>
);

export default PressCenterPage;
